import EventInstance from 'pages/calendar/modules/EventInstance'

import { getTodoDB } from 'pages/todo/modules/todoDB'
import * as todoFolderSync from 'pages/todo/modules/TodoFolderSync'
import * as todoSync from 'pages/todo/modules/TodoSync'
import { TodoItem } from 'pages/todo/modules/TodoItem'
import { TodoFolder } from 'pages/todo/modules/TodoFolder'

/**
 * Get todo instances within a date range
 * @param startDate - Start date of the range
 * @param endDate - End date of the range
 * @returns Promise resolving to array of EventInstance objects representing todos
 */
export const getTodoInstances = async (
  startDate: Date,
  endDate: Date,
): Promise<EventInstance[]> => {
  let todoList: TodoItem[]
  let todoSyncFolders: TodoFolder[]
  try {
    todoList = await getTodoDB().getTodosWithRange(startDate, endDate)
    todoSyncFolders = await todoFolderSync.getSyncFolders()
  } catch (error) {
    // Todo 조회 실패가 캘린더 일정 렌더링까지 막지 않도록 Todo 만 비운다
    console.error('[getTodoInstances] Failed to load todos:', error)
    return []
  }
  const todoInstances: EventInstance[] = []

  todoList.forEach((todo) => {
    todoSyncFolders.forEach((folder) => {
      if (folder.url === todo.folderUrl) {
        todoInstances.push(
          new EventInstance(
            todo.url,
            todo.etag,
            folder.calendarColor._cdata,
            null,
            null,
            null,
            todo,
          ),
        )
      }
    })
  })

  return todoInstances
}

/**
 * Add a listener for todo change events
 * @param callback - Function to be called when todos change
 */
export const addTodoChangeListener = (callback: () => void): void => {
  todoSync.addTodoFolderListener(callback)
  todoSync.addTodoItemListener(callback)
}

/**
 * Remove a listener for todo change events
 * @param callback - Function to remove from listeners
 */
export const removeTodoChangeListener = (callback: () => void): void => {
  todoSync.removeTodoFolderListener(callback)
  todoSync.removeTodoItemListener(callback)
}
